__turbopack_context__.v({
  "awardsItem": "style-module-scss-module__F4OPZa__awardsItem",
  "awardsList": "style-module-scss-module__F4OPZa__awardsList",
  "content": "style-module-scss-module__F4OPZa__content",
  "textWrapper": "style-module-scss-module__F4OPZa__textWrapper",
  "title": "style-module-scss-module__F4OPZa__title",
  "wrapper": "style-module-scss-module__F4OPZa__wrapper",
});
